/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SendProfessionalDocumentsRequest = {
  type: 'array',
  contains: {
    type: 'ProfessionalDocument',
  },
} as const;
